import { 
  getMyProducts, 
  createMyProduct, 
  updateMyProduct, 
  deleteMyProduct 
} from "./asyncThunks";

export const getMyProductsBuilder = (builder) => {
  builder.addCase(getMyProducts.pending, (state) => {
    state.getMyProductsPending = true;
    state.error = null;
  });
  builder.addCase(getMyProducts.fulfilled, (state, { payload }) => {
    state.getMyProductsPending = false;
    state.myProducts = payload.data;
    state.myProductsTotal = payload.total;
    state.myProductsPage = payload.page;
    state.myProductsPerPage = payload.perPage;
    state.myProductsMaxReached = payload.maxReached;
    state.bandInfo = payload.band || null;
  });
  builder.addCase(getMyProducts.rejected, (state, { payload }) => {
    state.getMyProductsPending = false;
    state.error = payload || "Failed to fetch my products";
  });
};

export const createMyProductBuilder = (builder) => {
  builder.addCase(createMyProduct.pending, (state) => {
    state.createMyProductPending = true;
    state.error = null;
  });
  builder.addCase(createMyProduct.fulfilled, (state, { payload }) => {
    state.createMyProductPending = false;
    // Add new product to the beginning of the list
    if (state.myProducts) {
      state.myProducts = [payload.data, ...state.myProducts];
    } else {
      state.myProducts = [payload.data];
    }
    if (state.myProductsTotal !== null) {
      state.myProductsTotal += 1;
    }
  });
  builder.addCase(createMyProduct.rejected, (state, { payload }) => {
    state.createMyProductPending = false;
    state.error = payload || "Failed to create product";
  });
};

export const updateMyProductBuilder = (builder) => {
  builder.addCase(updateMyProduct.pending, (state) => {
    state.updateMyProductPending = true;
    state.error = null;
  });
  builder.addCase(updateMyProduct.fulfilled, (state, { payload }) => {
    state.updateMyProductPending = false;
    // Update product in the list
    if (state.myProducts) {
      const index = state.myProducts.findIndex(p => p.id === payload.data.id);
      if (index !== -1) {
        state.myProducts[index] = payload.data;
      }
    }
  });
  builder.addCase(updateMyProduct.rejected, (state, { payload }) => {
    state.updateMyProductPending = false;
    state.error = payload || "Failed to update product";
  });
};

export const deleteMyProductBuilder = (builder) => {
  builder.addCase(deleteMyProduct.pending, (state) => {
    state.deleteMyProductPending = true;
    state.error = null;
  });
  builder.addCase(deleteMyProduct.fulfilled, (state, { payload }) => {
    state.deleteMyProductPending = false;
    // Remove product from the list
    if (state.myProducts && payload.data && payload.data.id) {
      state.myProducts = state.myProducts.filter(p => p.id !== payload.data.id);
      if (state.myProductsTotal !== null) {
        state.myProductsTotal -= 1;
      }
    }
  });
  builder.addCase(deleteMyProduct.rejected, (state, { payload }) => {
    state.deleteMyProductPending = false;
    state.error = payload || "Failed to delete product";
  });
};